import serviceProject from "../serviceProject";

const Ingestion = {
  ...serviceProject,
  resource: "ingestions"
};
export default Ingestion;
